/* Configuación -  registro de acceso a los usuarios por proceso*/

//*react- recursos
  import { useState, useEffect} from "react";
  import { Panel, PanelGroup } from "rsuite";
  
//*componentes-utiles
//*clases 
//*imágenes

//*archivo & componentes (otros componentes enlazados)
  import ConfiguracionPanel from "./Configuracion.Panel"; 

//*api's (servicios y store)
  import configurationsStore from "../../../../api/recursos/configurations/configurations.store"; 

//*store's

//*datos
  import etiquetasSSC from "../../../../datos/json/etiquetasSSC.json"

//*funciones

//*interface  
  interface propsConfiguracion {
    tokenStore: any;
    menuStore: any;
    quitaErrorPagina:any;
    recargaPaginaSSC:any;
    recargaPaginaSSC_Not:any;
  }  

//*componente
  export default function Configuracion(props: propsConfiguracion){
    
      //*api store
        const { panelStore, cierraPanelStore, cambiaPanelStore,
              } =  
          configurationsStore((state:any) =>( { 
                panelStore: state.panelStore,
                cierraPanelStore: state.cierraPanelStore,
                cambiaPanelStore: state.cambiaPanelStore,
      }));
      
      //*store's
      
      //*datos
      
      //*constantes y variables
        let eti = etiquetasSSC.Configuracion;
        let x0, x1, x1a, x2, x3 = '';

      //*usestate
        const [swRecarga, setSwRecarga] = useState(false); //usado para remasterizar
        const [swRecargaConfiguracion, setSwRecargaConfiguracion] = useState(false); //usado para remasterizar esta página
       
      //*useEffect

        useEffect(()=> { // al montar
          console.log('Configuracion - monto')
          props.quitaErrorPagina();
          cierraPanelStore();
          //console.clear();
        },[]);
        
        useEffect(()=> { // uso este puente para recargar elementos del front
          console.log('Configuracion - rederizando............');
          //console.log("**panelStore.", panelStore);
          setSwRecargaConfiguracion(!swRecargaConfiguracion);
        },[swRecarga]);

      //* interface (parametros de entrada)

      //*funciones
        const recargaPaginaSSC = () => {props.recargaPaginaSSC() } //ejecuta la función que esta en Contenido que llama a la renderización de PaginaSSC

        const recargaPaginaSSC_Not = () => { props.recargaPaginaSSC_Not() } //ejecuta la función que esta en Contenido que llama de PaginaSSC recargar el api de notificaciones para la campana

        const recargaConfiguracion = (id:any) => {
          //alert('recargaConfiguracion');
          //console.log('recargaConfiguracion....')
          setSwRecarga(!swRecarga); // con esto ejecuto un useEffect, lo uso para renderizar el front 
        }

        const abreCierraPanel = (idPanel:any) => {  // abre y cierra el menupanel
          //alert('abreCierraPanel...' + idPanel)
          cambiaPanelStore(idPanel);
          setSwRecarga(!swRecarga);
        }

      //*vista
      return(
        
        <div>   
          <hr/>  
          { panelStore?.map((p:any, indexM:any) => (
            /*x2 forma el contendio del header del panel*/
            (x2 = (
                <div id={`divpanel_${p.id}`}>
                  <span id="panelDes">
                    <span className='h4'> {p.texto} </span>
                    <br />
                  </span>
                </div>
            )),
            (<>
                <PanelGroup accordion  >
                  <Panel
                    header={x2}
                    key={p.key}
                    id={p.id}
                    collapsible={p.abierto}
                    onClick={() => abreCierraPanel(p.id)}
                  >
                  </Panel>
                  {p.abierto
                    && <ConfiguracionPanel
                          key={p.id}
                          tokenStore={props.tokenStore}
                          idPanel = {p.id}
                          panelStore = {panelStore}
                          recargaPaginaSSC = {recargaPaginaSSC}
                          recargaPaginaSSC_Not  = {recargaPaginaSSC_Not }
                        /> 
                  }
                </PanelGroup> 
                <hr />
            </>)
          ))} 
        </div>
      
      )
  }
